import { Link as RouterLink } from 'react-router-dom';
import { Snackbar } from '@rossum/components/snackbar/Snackbar';
import { Button } from '@rossum/ui/material';
import { Severity, ToastAction } from './types';

export type ToasterMessageProps = {
  id?: string;
  title: string;
  severity: Severity;
  onClose?: () => void;
  toastActions?: ToastAction[];
};

const renderAction = (toastAction?: ToastAction) => {
  if (!toastAction) return null;

  const { to, label, onClick, dataTestId } = toastAction;

  return (
    <Button
      key={label}
      LinkComponent={to ? RouterLink : undefined}
      {...(to ? { to } : {})}
      sx={{ px: 1, width: 'max-content' }}
      variant="text"
      size="small"
      color="secondary"
      onClick={onClick}
      data-testid={dataTestId}
    >
      {label}
    </Button>
  );
};

const renderActions = (toastActions: ToastAction[] = []) => {
  return <>{toastActions.map(renderAction)}</>;
};

export const ToasterMessage = ({
  title,
  severity,
  onClose,
  toastActions,
}: ToasterMessageProps) => (
  <Snackbar
    open
    content={title}
    isError={severity === 'error'}
    onClose={onClose}
    action={renderActions(toastActions)}
    dataTestId={`${severity}-toaster`}
  />
);
